export default "__VITE_ASSET__Ck2o4MaM__"